import {ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {filter, take, takeUntil} from 'rxjs/operators';
import * as _ from 'lodash';
import {LoadPathwaysAction} from '@ispm-client/modules/pathways/store';
import {Observable} from 'rxjs/Observable';
import {
  selectPrefetchDataEnabledOnPathwayTest
} from '@ispm-client/modules/pathways/store/selectors/prefetch-data.selectors';
import {PathwaysConfigurationService} from "@ispm-client/modules/pathways/services";
import {Subject} from "rxjs";
import {IWorkflow} from '@ispm/core/interfaces/workflow.interface';
import {IRevision} from '@ispm/dashboard/test/interfaces/diagnostic-order.interface';
import {IgenomicsState} from '@ispm/core/interfaces/genomics-state.interface';
import {selectActiveJobId, selectActiveWorkflow} from "@ispm/workflow/store/workflow-config.selectors";
import { TestService } from '@ispm/dashboard/test/services/test.service';
import {RouterManagerService} from "@ispm/core/services/router-manager.service";

@Component({
  selector: 'ispm-pathways',
  templateUrl: './pathways.component.html',
  styleUrls: ['./pathways.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class PathwaysComponent implements OnInit, OnDestroy {
  isPathwayActive: boolean;
  hideBpmnLogo: boolean;
  verticalLeftContainerPatientView = false;
  isSelectPathwayBarEnabled: boolean;
  selectPathwayTitle: string;

  private destroyed$: Subject<any> = new Subject();

  currentWorkflow: IWorkflow;
  currentRevision: IRevision;
  activeJobId: string;
  private RETRY_INTERVAL = 1000; //msec

  constructor(private store$: Store<any>,
    private testService:TestService,
    private pathwayConfService: PathwaysConfigurationService,
    private routerManagerService: RouterManagerService,
    private store: Store<IgenomicsState>) {
  }

  ngOnInit(): void {
    this.store.pipe(takeUntil(this.destroyed$.asObservable()), select(selectActiveWorkflow), filter(workflow => !!workflow))
      .subscribe(workflow => {
        this.currentRevision = workflow?.revisions.find(revision => revision.id === this.routerManagerService.parameters.revisionId);
        this.currentWorkflow = workflow;
      });

    // GEN-148874 Workflow request should arrive to needed 'UISelectPathway' and 'activeJob' should be known
    // before dispatch the 'LOAD_PATHWAYS' action

    this.activeJobId = null;
    this.waitForInitActiveJob();

    const testConfiguration = this.testService.testConfiguration;
    if (testConfiguration) {
      this.hideBpmnLogo = _.get(testConfiguration, 'hideBpmnLogo', true);
      this.verticalLeftContainerPatientView = !!testConfiguration.VerticalLeftContainerPatientView;
      this.isSelectPathwayBarEnabled = testConfiguration.isSelectPathwayBarEnabled;
      this.selectPathwayTitle = testConfiguration.SelectPathwayBarTitle;
    }

    const prefetchDataIsEnabled: Observable<boolean> = this.store$.pipe(select(selectPrefetchDataEnabledOnPathwayTest), take(1));
    prefetchDataIsEnabled.subscribe(prefetchIsEnabled => {
      if (!prefetchIsEnabled && !!this.activeJobId) {
        this.store$.dispatch(new LoadPathwaysAction());
      }
    });

    this.pathwayConfService.isPathwaySelectionEnabled()
      .takeUntil(this.destroyed$.asObservable())
      .subscribe(enabled => this.isPathwayActive = enabled);
  }

  private waitForInitActiveJob() {
    this.store.pipe(takeUntil(this.destroyed$.asObservable()), select(selectActiveJobId))
      .subscribe(activeJobId => {
        if (activeJobId) {
          this.activeJobId = activeJobId;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
